/**
 * Chevron — the ONE expand/collapse indicator for the Control Center and Admin.
 *
 * John, 2026-10-24: "Everything that expands should have that chevron."
 * (memory/feedback_every_expandable_has_a_chevron.md, design-system D1.)
 *
 *   - sits on the RIGHT of its row (put it last in a flex row with justify-between);
 *   - points DOWN when closed, UP when open (180° rotation, never 90°);
 *   - keeps clear space before the row's right edge (margin-right in `.section-chevron`,
 *     app/shared/src/styles/design-system.css §7) — never flush.
 *   - `inline`: inside a button or pill whose own right padding (≥12px) is the clear space.
 *   - inside a <details>: <summary className="disclosure-summary">… <Chevron /></summary> —
 *     leave `open` out; CSS turns it from the details' own open state.
 *
 * Decorative only (aria-hidden): the element that toggles carries `aria-expanded`.
 * The census app/shared/src/__tests__/expandableChevronCensus.test.ts fails on an
 * expandable (aria-expanded / <details>) that does not render this component.
 */
export function Chevron({ open = false, inline = false, className = '' }: { open?: boolean; inline?: boolean; className?: string }) {
  return (
    <i
      className={`fa-solid fa-chevron-down section-chevron${inline ? ' section-chevron-inline' : ''}${open ? ' rotate-180' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      data-chevron=""
    />
  )
}
